export default __webpack_public_path__ + "static/media/Mask_Group_48.9f6ac05c.svg";